module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_ccaas-b8d8163d083b0a07d97f3fc66f448c09.png";